<div class="menu-card" role="link" [routerLink]="routerLink()" [relativeTo]="relative() ? route : null" [title]="titleAttribute()">
  <h2 class="menu-card__title">{{ title() }}</h2>
  <div class="menu-card__subtitle">{{ subtitle() }}</div>
</div>
